import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { PROFILES } from "@/lib/brand";

export default function WhoAreYou({ lang }) {
  return (
    <section className="border-b border-tertiary bg-white" data-testid="home-profiles">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
        <div className="mb-10 max-w-2xl">
          <h2 className="font-serif text-3xl tracking-tight text-anthracite sm:text-4xl">
            {lang === "fr" ? "Vous êtes…" : "You are…"}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-anthracite/70 md:text-lg">
            {lang === "fr"
              ? "RSTI vous aide à trouver les opportunités, les partenaires, les financements et les marchés adaptés à vos besoins."
              : "RSTI helps you find the opportunities, partners, funding and markets that fit your needs."}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
          {PROFILES.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Circle;
            const [title, sub] = lang === "fr" ? p.fr : p.en;
            return (
              <Link
                key={p.key}
                to={`/connect?profile=${p.key}`}
                data-testid={`profile-card-${p.key}`}
                className="group relative flex min-h-[170px] flex-col justify-between border border-tertiary bg-ivory p-5 transition-all duration-300 hover:-translate-y-1 hover:border-champagne hover:shadow-[0_12px_40px_rgba(201,169,110,0.18)] animate-fade-up sm:min-h-[200px] sm:p-6"
                style={{ animationDelay: `${i * 50}ms` }}
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-anthracite text-champagne transition-colors duration-300 group-hover:bg-champagne group-hover:text-anthracite">
                  <Icon className="h-5 w-5" strokeWidth={1.5} />
                </span>
                <div>
                  <h3 className="font-serif text-lg leading-snug text-anthracite sm:text-xl">{title}</h3>
                  <p className="mt-1.5 hidden text-xs leading-relaxed text-anthracite/60 sm:block sm:text-sm">{sub}</p>
                </div>
                <ArrowRight className="absolute right-5 top-5 h-4 w-4 text-anthracite/25 transition-all duration-300 group-hover:translate-x-1 group-hover:text-champagne" strokeWidth={1.5} />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
